/**
 * Quantités saisies (documents stock, variantes) : entier ≥ 0.
 */
export function normalizeNonNegativeIntegerQuantity(
    value: string | number | null | undefined
): number {
    const raw = Number(value);
    return Math.max(0, Math.floor(Number.isFinite(raw) ? raw : 0));
}

/** Bloque saisie clavier de signes / exposant sur un champ quantité ≥ 0. */
export function preventNonNegativeQuantityKeydown(event: KeyboardEvent): void {
    if (['-', 'e', 'E', '+'].includes(event.key)) {
        event.preventDefault();
    }
}
